import script from "./processPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./processPlan.vue?vue&type=script&setup=true&lang=ts"

import "./processPlan.vue?vue&type=style&index=0&id=72c22f5a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c22f5a"]])

export default __exports__